import { render } from "./ExpenseReceiptDetailTabDetail.vue?vue&type=template&id=15b95cb9&scoped=true"
import script from "./ExpenseReceiptDetailTabDetail.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptDetailTabDetail.vue?vue&type=script&lang=js"

import "./ExpenseReceiptDetailTabDetail.vue?vue&type=style&index=0&id=15b95cb9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b95cb9"]])

export default __exports__